module.exports = __webpack_public_path__ + "static/tarjeta-grande-table-7972a03210e7a63627c4d9347466e2b3.png";